<template>
  <Modal
    id="no-mentor-found"
    :modal="noMentorFoundModalRef"
    :steps="[{ component: NoMentorFoundContent, id: 'no-mentor-found' }]"
  />
</template>

<script setup lang="ts">
import NoMentorFoundContent from '@/features/matching/components/matching-modals/no-mentor-found-modal/no-mentor-found-content/no-mentor-found-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetNoMentorFoundModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const noMentorFoundModalRef = selectGetNoMentorFoundModal(modalsStore)
</script>
